import React, { cloneElement } from 'react';

import { dataLayerProvider, tracker } from '@femtasy/helpers';

import CourseItem from 'containers/AudioCourse/CourseItem';
import { calculateEpisodeState } from 'containers/AudioCourse/helpers';
import { SAC_TRACKING_NAME } from 'containers/SexualAnxietyClass';

import { isProduction } from 'helpers/env';

import { AudioCourseStory } from '..';
import './style.scss';

interface CourseAudioListProps {
  stories: AudioCourseStory[];
  activeStoryId?: string;
}

const CourseAudioList = ({ stories, activeStoryId }: CourseAudioListProps) => {
  const [expanded, setExpanded] = React.useState<number | false>();

  const trackOnOpen = React.useCallback(
    (episodeNumber: number, audioName: string) => {
      tracker.sendEvent(
        SAC_TRACKING_NAME,
        [
          {
            action: 'expand_accordion',
            audioName,
            episodeNumber,
          },
        ],
        !isProduction(),
        [dataLayerProvider],
      );
    },
    [],
  );

  const trackOnClose = React.useCallback(
    (episodeNumber: number, audioName: string) => {
      tracker.sendEvent(
        SAC_TRACKING_NAME,
        [
          {
            action: 'collapse_accordion',
            audioName,
            episodeNumber,
          },
        ],
        !isProduction(),
        [dataLayerProvider],
      );
    },
    [],
  );

  const handleChange = React.useCallback(
    (panel: number) => (newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    },
    [],
  );

  return (
    <div className="CourseAudioList">
      <div className="CourseAudioList__items">
        {stories.map((story, index) => {
          const position = index + 1;

          return cloneElement(
            <CourseItem
              accordionItemId={`${index}-${story.id}`}
              episodeNumber={position}
              episodeState={calculateEpisodeState(story, activeStoryId)}
              key={`${index}-${story.id}-${position}`}
              onClose={() => trackOnClose(position, story.title)}
              onOpen={() => trackOnOpen(position, story.title)}
              story={story}
            />,
            {
              expanded: expanded === index,
              onChange: handleChange(index),
              index,
            },
          );
        })}
      </div>
    </div>
  );
};

export default CourseAudioList;
